import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { FarmaError, FarmaFuncaoError } from 'src/integracoes/modelos/erros';
import {
  CREATE_PAINEL_INIT,
  MODIFY_PAINEL_INIT,
  LIST_PAINEL_INIT,
  DELETE_PAINEL_INIT
} from '../actionTypes';
import {
  paineisErrorMsg,
  modifyPainelSuccess,
  createPainelSuccess,
  listPainelSuccess,
  deletePainelSuccess
} from './actions';
import { Paineis } from 'src/integracoes/servicos/mongo-atlas/funcoes/paineis';
import { User as RealmUser } from 'realm-web';
import { Painel } from 'src/@types/emp';

interface FetchListaPainelResult {
  isError: boolean;
  allPaineis: any[] | null;
  errorMessage: string | null;
}


// -------------------Listar Paineis-----------------------------

const listPainelAsync = async ({ usuarioMongoAppServices }: { usuarioMongoAppServices: RealmUser })  => {
  try {
    const { status, dados, mensagem } = await Paineis.obtem(usuarioMongoAppServices);
    if (status) {
      return { 
        isError: false,
        allPaineis: dados,
        errorMessage: null 
      };
    }
    return {
      isError: true,
      allPaineis: null,
      errorMessage: mensagem
    };
  } catch (error: any) {
    throw new FarmaFuncaoError(error);
  }
};

function* listPainelMiddle({ payload }: { payload: any, type: any }) {
  const usuarioMongoAppServices = payload;
  try {
    const resposta: FetchListaPainelResult = yield call(listPainelAsync, { usuarioMongoAppServices });

    if (!resposta.isError) {
      yield put(listPainelSuccess({ allPaineis: resposta.allPaineis }));
    } else {
      yield put(paineisErrorMsg({ msg: resposta.errorMessage }));
    }
  } catch (error: any) {
    yield put(paineisErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchListPainel() {
  yield takeEvery(LIST_PAINEL_INIT, listPainelMiddle);
}

// ---------------------------Criar Painel---------------------------------------------------------

const createPainelAsync = async ({ usuarioMongoAppServices, painel }:
  { usuarioMongoAppServices: RealmUser, painel: Painel }
) => {
  try {
    const {status, dados, mensagem} = await Paineis.cria(usuarioMongoAppServices, painel);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
       return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* createPainelMiddle({ payload }: { payload: any, type: any }) {
  const { usuarioMongoAppServices, painel } = payload;
  try {
    const { isCreated, msg, data } = yield call(createPainelAsync, {
      usuarioMongoAppServices,
      painel
    });
    if (isCreated) {
      yield put(createPainelSuccess({ isCreated, msg, painel: data }));
    } else {
      paineisErrorMsg({msg: msg})
    }
  } catch (error: any) {
    yield put(paineisErrorMsg({ msg: error.mensagem }));
  }
}

export function* watchCreatePainel() {
  yield takeEvery(CREATE_PAINEL_INIT, createPainelMiddle);
}


// ---------------------Atualizar Painel --------------------------------------------------

export const modifyPainel = async ({ usuarioMongoAppServices, painel }:
  { usuarioMongoAppServices: RealmUser, painel: Painel }
) => {
  try {
    const { status, dados, mensagem }  = await Paineis.atualiza(usuarioMongoAppServices, painel);

    if (status) {
      return { 
        isUpdated: true, 
        data: dados,
        msg: mensagem 
      };
    } else {
      return { 
        isUpdated: false, 
        data: null,
        msg: mensagem 
      };
    }
  } catch (error: any) {
    console.error(error);
    throw new FarmaError(error);
  }
};

function* parseModifyPainel({ payload }: { payload: any, type: any }) {
  const { usuarioMongoAppServices, painel } = payload;
  try {
    const {isUpdated, msg, data} = yield call(modifyPainel,  {
      usuarioMongoAppServices,
      painel
    });
    if (isUpdated) {
      yield put(
        modifyPainelSuccess({
          isUpdated,
          msg,
          painel: data
        })
      );
    } else {
      yield put(paineisErrorMsg({ msg }));
    }
  } catch (error) {
    console.error(error);
    yield put(paineisErrorMsg({ msg: error }));
  }
}

export function* watchModifyPainel() {
  yield takeEvery(MODIFY_PAINEL_INIT, parseModifyPainel);
}

// -------------------------- Deletar Painel --------------------

export const deletePainel =  async ({ usuarioMongoAppServices, painel }:
  { usuarioMongoAppServices: RealmUser, painel: Painel }
) => {
  try {
    const { status, dados, mensagem } = await Paineis.deleta(usuarioMongoAppServices, painel);
    if (status) {
      return {
        isDeleted: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isDeleted: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

export function* parseDeletePainel({ payload }: { payload: any, type: any }) {
  const { usuarioMongoAppServices, painel } = payload;

  const { isDeleted, msg, data } = yield call(deletePainel, {usuarioMongoAppServices, painel});
  try {
    if (isDeleted) {
      yield put(
        deletePainelSuccess({
          isDeleted,
          msg,
          painel: data
        })
      );
    } else {
      yield put(paineisErrorMsg({ msg }));
    }
  } catch (error) {
    console.error(error);
    yield put(paineisErrorMsg({ msg: error }));
  }
}

export function* watchDeletePainel() {
  yield takeEvery(DELETE_PAINEL_INIT, parseDeletePainel);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchCreatePainel),
    fork(watchListPainel),
    fork(watchModifyPainel),
    fork(watchDeletePainel)
  ]);
}
